import { AstraParagraph } from '~/astra'
import { PractitionerChipWithTooltip } from '~/components'
import { Include, PractitionerScheduleLocationActivityLog, usePractitioner } from '~/storm'
import { getPractitionerFullname } from '~/utils/dips'
import { getInitials } from '~/utils/user'

import { ActivityLogEntryWrapper } from '../../../shared'
import { StatusLocationIcon } from './StatusLocationIcon'
import { getActivityTypeLabel } from './utils'

type Props = {
    locationLogEntry: Include<PractitionerScheduleLocationActivityLog, { location: true }>
    pageView: 'practitioner' | 'location'
}

export const PractitionerScheduleLocationActivityLogEntry = ({ locationLogEntry, pageView }: Props) => {
    const practitioner = usePractitioner({ where: { id: locationLogEntry.practitioner_id }, include: { dipsResource: true } })

    const { location } = locationLogEntry
    if (!location) return null

    if (!practitioner) return null

    const performedBy = locationLogEntry.performed_by ?? ''
    const initials = getInitials(performedBy)
    const activityTypeLabel = getActivityTypeLabel(locationLogEntry.activity_type)
    const performedAt = locationLogEntry.performed_at
    const icon =
        pageView === 'practitioner' ? (
            <StatusLocationIcon entity={location} activityType={locationLogEntry.activity_type} />
        ) : (
            <PractitionerChipWithTooltip shortName={practitioner.short_name} size="small" />
        )

    return (
        <ActivityLogEntryWrapper icon={icon} performedBy={performedBy} initials={initials} performedAt={performedAt}>
            <AstraParagraph variant="body">
                {activityTypeLabel} <span className="italic">{pageView === 'practitioner' ? 'Stue' : getPractitionerFullname(practitioner)}</span>
            </AstraParagraph>
        </ActivityLogEntryWrapper>
    )
}
